module.exports = __webpack_public_path__ + "media/flags/gp-5896e949.svg";